import { ChangeDetectionStrategy, ChangeDetectorRef, Component, forwardRef, Input } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';

import { map, of } from 'rxjs';

import { LanguageEnum, RolesService, UsersService } from '@api';
import { TranslateService } from '@ngx-translate/core';

import { DefaultModule } from '@module';

import { BaseDropdown, LibDropdownModule } from 'pn-core-code';

export interface translationsDto {
  id: string;
  name: string;
}
@Component({
  selector: 'shared-user-dropdown',
  standalone: true,
  imports: [DefaultModule, LibDropdownModule],
  templateUrl: '/node_modules/pn-core-code/src/base/base-dropdown/base-dropdown.html',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => UserDropdownComponent),
      multi: true,
    },
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UserDropdownComponent extends BaseDropdown<any> {


  languageEnum = LanguageEnum;

  constructor(
    protected override cdr: ChangeDetectorRef,
    protected override translateService: TranslateService,
    private usersService: UsersService,
  ) {
    super(cdr, translateService);
  }

  override ngOnInit() {
    super.ngOnInit();
  }


  protected override apiOptionListGet$() {
    return this.usersService.usersDropdownGet$(1, 9999, undefined, undefined, undefined, undefined, undefined, true, 'firstname,asc').pipe(
      map(res => {

        let translationsList: any[] = [];

        for (const data of res) {
          translationsList.push({
            id: data.id,
            name: data.firstname + ' ' + data.lastname,
          });

        }
        // console.log('translationsList', translationsList);
        return translationsList;
      }));
  }
}
